import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询员工应用认证信息
export function queryStaffAppAuth(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/staff/queryStaffAppAuth',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      // res 格式: { records, total, data }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 生成认证二维码
// common=true 时生成通用认证二维码（不带员工信息，扫码后跳转员工端登录页自动绑定）
export function generatorQrCode(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/staff/generatorQrCode',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}